var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pageTable',{ref:"table",attrs:{"tableTitle":_vm.tableColumn,"searchData":{order_id:this.id},"showSearchForm":false,"tableApi":"admin/settlement/getOrderSettleDetail"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }